module.exports = __webpack_public_path__ + "img/stock4.3c922554.png";